import { makeStyles } from '@material-ui/core';
import logo from './khonology-logo.png';

const useStyles = makeStyles({
  img: {
    width: 172,
    height: 'auto',
    display: 'block',
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return <img className={classes.img} src={logo} alt="Khonology" />;
};
